import { Box, Image } from '@chakra-ui/react';
import type { IEvent } from '../../../lib';

interface IEventImageProps {
	event: IEvent;
	isListItem: boolean;
	imageHeight: string;
	haveFeaturedImage: boolean;
}

export const EventImage = ({ event, isListItem, imageHeight, haveFeaturedImage }: IEventImageProps) => {
	if (haveFeaturedImage) {
		return (
			<Box w='100px' height={imageHeight}>
				<Image h='full' minW='100px' src={event.image} />
			</Box>
		);
	}

	if (event.image && !isListItem) {
		return <Image src={event.image} minH='150px' className='event-popover__image' />;
	}

	return null;
};
